import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, Paper } from "@mui/material";
import RecapInfoBox from "./RecapInfoBox";
import AssuranceCard from "./AssuranceCard";
import { useTranslation } from "react-i18next";

const InsuranceStep = ({ formData, setFormData, handleNext, handleBack }) => {
  const { t } = useTranslation("parcours-client/InsuranceStep");

  const [assurances, setAssurances] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAssurances = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_VENDOR_SYB_API}/insurances`);
        const data = await res.json();
        setAssurances(data.insurances || []);
      } catch (err) {
        console.error("Erreur lors de la récupération des assurances", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAssurances();
  }, []);

  const buildFeatures = (a) => {
    const out = [];
    if (a.casse) out.push(t("features.breakage"));
    if (a.vol) out.push(t("features.theft"));
    if (a.panne) out.push(t("features.breakdown"));
    if (a.tentative_vol) out.push(t("features.attemptedTheft"));
    if (a.oxydation) out.push(t("features.oxidation"));
    return out;
  };

  const handleSouscrire = (assurance) => {
    setFormData({
      ...formData,
      assurance: {
        id: assurance.id,
        nom: assurance.name,
        prix: assurance.price,
        engagement: assurance.engagement,
        product_code: assurance.product_code,
        description: assurance.description,
        priseEnCharge: assurance.prise_en_charge,
        pdfIpid: assurance.pdf_ipid,
        pdfNotice: assurance.pdf_notice,
        features: buildFeatures(assurance),
      },
    });
    handleNext();
  };

  return (
    <Box sx={{ mt: 10, px: { xs: 2, md: 4 } }}>
      <Typography
        sx={{
          fontWeight: 900,
          fontSize: { xs: "2.2rem", md: "3.2rem" },
          textAlign: "center",
          color: "#000",
          mb: 6,
        }}
      >
        {t("title.part1")}{" "}
        <Box component="span" sx={{ color: "#4eb933" }}>
          {t("title.highlight")}
        </Box>
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 6,
          alignItems: "flex-start",
        }}
      >
        <Box sx={{ flexBasis: "62%" }}>
          {loading ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <CircularProgress color="success" size={24} />
              <Typography>{t("loading")}</Typography>
            </Box>
          ) : assurances.length === 0 ? (
            <Typography>{t("noData")}</Typography>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
              {assurances.map((a) => (
                <AssuranceCard
                  key={a.id}
                  name={a.name}
                  description={a.description}
                  price={a.price}
                  engagement={a.engagement}
                  pdfIpid={a.pdf_ipid}
                  pdfNotice={a.pdf_notice}
                  features={buildFeatures(a)}
                  onSouscrire={() => handleSouscrire(a)}
                  onDevis={() => console.log("Demande de devis pour:", a.name)}
                />
              ))}
            </Box>
          )}
        </Box>

        <Box
          sx={{
            flexBasis: "38%",
            minWidth: 300,
            position: "sticky",
            top: 140,
            alignSelf: "flex-start",
            height: "fit-content",
          }}
        >
          <Paper
            elevation={1}
            sx={{
              borderRadius: "16px",
              backgroundColor: "#f4f4f4",
              p: 3,
              fontSize: "0.95rem",
            }}
          >
            <RecapInfoBox formData={formData} onEdit={handleBack} />
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default InsuranceStep;